import { CommonModule } from '@angular/common';
import { Component, input, output, ViewChild } from '@angular/core';
import { MenuComponent, CustomMenuItem } from '../../../@core/components/ui/menu/menu.component';
import { IProject } from '../../../@core/models/model';
import { Pencil, Trash2 } from 'lucide-angular';
import { IconSourceEnum } from '../../../@core/components/ui/icon/icon.component';

@Component({
  selector: 'app-project-actions-menu',
  standalone: true,
  imports: [CommonModule, MenuComponent],
  templateUrl: './project-actions-menu.component.html',
})
export class ProjectActionsMenuComponent {
  project = input.required<IProject>();
  edit = output<IProject>();
  delete = output<IProject>();

  @ViewChild('actionsMenu') private menuRef!: MenuComponent;

  get menuItems(): CustomMenuItem[] {
    return [
      {
        icon: 'pencil',
        iconSource: IconSourceEnum.LUCIDE,
        label: 'Edit',
        callback: () => this.onEdit(),
        class: 'w-full !justify-start !rounded-base'
      },
      {
        icon: 'trash-2',
        iconSource: IconSourceEnum.LUCIDE,
        label: 'Delete',
        callback: () => this.onDelete(),
        class: 'w-full !justify-start !rounded-base text-red-600'
      }
    ];
  }

  showActionsMenu(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.menuRef) {
      this.menuRef.toggle(event);
    }
  }

  onEdit(): void {
    this.menuRef?.hide();
    this.edit.emit(this.project());
  }

  onDelete(): void {
    this.menuRef?.hide();
    this.delete.emit(this.project());
  }
}
